// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Xv3C","dragIcon":"SortableItem_dragIcon__2tZvZ","disabled":"SortableItem_disabled__3Smxf"};